import axios from "axios"
import React, { useEffect, useState } from "react"
import DatePicker from "react-datepicker"
import { Col, Input, Label, Row } from "reactstrap"
import Select from "react-select"
import MultipleValueTextInput from "react-multivalue-text-input"
import { useHistory } from "react-router-dom"
import Switch from "react-switch"

const VisitsFilter = ({
  filteredValues,
  setFilteredValues,
  setAuth,
  isAreaManger,
  statusOptions,
}) => {
  const history = useHistory()

  const [users, setUsers] = useState([])

  const [dateRange, setDateRange] = useState([null, null])
  const [startDate, endDate] = dateRange

  const [dateCreateRange, setCreateDateRange] = useState([null, null])
  const [startCreateDate, endCreateDate] = dateCreateRange

  const convertDate = value => {
    let day = value.getDate() + ""
    day = day.length === 1 ? `0${day}` : day
    let month = value.getMonth() + 1 + ""
    month = month.length === 1 ? `0${month}` : month
    let year = value.getFullYear()
    return `${year}-${month}-${day}` || null
  }

  const [categoryList, setCategoryList] = useState([])

  useEffect(() => {
    const formData = {
      PerToken: localStorage.getItem("token"),
      PerUserID: localStorage.getItem("id"),
      PerRoleID: localStorage.getItem("userRoleID"),
      Catagory: "Inspection",
    }
    axios
      .post(process.env.REACT_APP_API_URL + "api/MenuUsersView", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let data = Object.entries(res.data)
        data.splice(-1)
        let dataUsers = data.map(user => ({
          value: user[1].UserID,
          label: `${user[1].FirstName} ${user[1].LastName}`,
        }))
        setUsers(dataUsers)
      })
      .catch(error => {
        console.log(error)
      })

    axios
      .post(process.env.REACT_APP_API_URL + "api/OpenAccess/TypeList", formData)
      .then(res => {
        if (res.data.error === true && res.data.message === "Access denied!") {
          setAuth(true)
          setTimeout(() => {
            history.push("/logout")
            setTimeout(() => {
              history.push("/login")
            }, 1000)
          }, 4000)
        }

        let array = Object.values(res.data)
        array.splice(-1)

        setCategoryList(
          array.map(item => ({ value: item.BCID, label: item.Name }))
        )
      })
      .catch(error => {
        console.log(error)
      })
  }, [])

  const [teamTask, setteamTask] = useState(false)
  const handleTeamTask = () => {
    setteamTask(!teamTask)
    setFilteredValues({
      ...filteredValues,
      teamTask: teamTask ? 2 : 1,
    })
  }
  const [DailyTask, setAdminChecked] = useState(false)
  const handleAdminChange = () => {
    setAdminChecked(!DailyTask)
    setFilteredValues({
      ...filteredValues,
      dailyTask: DailyTask ? 2 : 1,
    })
  }

  return (
    <div>
      <Row>
        {/* ******************** Create Visit Date *************************** */}
        <Col sm={3}>
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 d-flex form-control border-dark ">
              <i className="bx bx-search-alt search-icon " />

              <DatePicker
                isClearable
                className="border-0"
                selectsRange={true}
                dateFormat="yyyy/MM/dd"
                startDate={startCreateDate}
                endDate={endCreateDate}
                onChange={update => {
                  setCreateDateRange(update)
                  setFilteredValues({
                    ...filteredValues,
                    startCreateDate: update[0] ? convertDate(update[0]) : null,
                    endCreateDate: update[1] ? convertDate(update[1]) : null,
                  })
                }}
                // withPortal
                placeholderText="Request Date ..."
              />
            </div>
          </div>
        </Col>

        {/* ********************  Visit Date *************************** */}
        <Col sm={3}>
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 d-flex form-control border-dark ">
              <i className="bx bx-search-alt search-icon " />

              <DatePicker
                isClearable
                className="border-0"
                selectsRange={true}
                dateFormat="yyyy/MM/dd"
                startDate={startDate}
                endDate={endDate}
                onChange={update => {
                  setDateRange(update)
                  setFilteredValues({
                    ...filteredValues,
                    startDate: update[0] ? convertDate(update[0]) : null,
                    endDate: update[1] ? convertDate(update[1]) : null,
                  })
                }}
                // withPortal
                placeholderText="Visit Date ..."
              />
            </div>
          </div>
        </Col>

        {/* ******************** RD3 Status *************************** */}
        <Col sm={3}>
          <div className="search-box me-3 col-12 p-0">
            <div className="position-relative mb-3 form-control border-dark py-0">
              <i className="bx bx-search-alt search-icon my-auto" />

              <Select
                isMulti
                options={statusOptions}
                name="VisitsStatus"
                className="react-select-container"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "transparent"
                      : "transparent",
                    borderColor: state.isSelected
                      ? "transparent"
                      : "transparent",
                    borderWidth: "0px",
                  }),
                }}
                value={filteredValues.RD3Status}
                onChange={e => {
                  setFilteredValues({
                    ...filteredValues,
                    status: e.map(item => item.value).join(","),
                  })
                }}
                classNamePrefix="select"
                placeholder="Visits Status..."
              />
            </div>
          </div>
        </Col>

        {/* ******************** Reference No *************************** */}
        <Col sm={3}>
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    referenceNo: allItems.join(","),
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    referenceNo: allItems.join(","),
                  })
                }
                type="number"
                name="referenceNo"
                placeholder="Reference No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>
        </Col>
      </Row>
      <Row className="d-flex justify-content-end">
        {/* ******************** Inspector *************************** */}
        <Col sm={3}>
          <div className="search-box me-3 col-12 p-0">
            <div className="position-relative mb-3 form-control border-dark py-0">
              <i className="bx bx-search-alt search-icon my-auto" />
              <Select
                isMulti
                options={users}
                name="inspector"
                className="react-select-container"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused
                      ? "transparent"
                      : "transparent",
                    borderColor: state.isSelected
                      ? "transparent"
                      : "transparent",
                    borderWidth: "0px",
                  }),
                }}
                onChange={e => {
                  setFilteredValues({
                    ...filteredValues,
                    inspector: e.map(item => item.value).join(","),
                  })
                }}
                classNamePrefix="select"
                placeholder="Inspector ..."
              />
            </div>
          </div>
        </Col>

        {/* ******************** Policy No *************************** */}
        <Col sm={3}>
          <div className="search-box me-3 col-12">
            <div className="position-relative mb-2 form-control border-dark py-1 d-flex flex-direction-colmun align-items-center overflow-hidden">
              <i className="bx bx-search-alt search-icon" />
              <MultipleValueTextInput
                onItemAdded={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    policyNo: allItems.join(","),
                  })
                }
                onItemDeleted={(item, allItems) =>
                  setFilteredValues({
                    ...filteredValues,
                    policyNo: allItems.join(","),
                  })
                }
                type="number"
                name="policyNo"
                placeholder="Policy No ..."
                className="border-0 mt-1"
              />
            </div>
          </div>
        </Col>

        {/* ******************** switch  *************************** */}
        <Col className="d-flex justify-content-end">
          {isAreaManger && (
            <div className="mt-2 ms-4">
              <label>Team Task</label>
              <Switch
                onChange={handleTeamTask}
                checked={teamTask}
                onColor="#4458b8"
                uncheckedIcon={false}
                checkedIcon={false}
                boxShadow="0px 1px 5px rgba(0, 0, 0, 0.3)"
                height={15}
                width={42}
                className="react-switch ms-2"
                id="material-switch"
              />
            </div>
          )}
          <div className="mt-2 ms-4">
            <label>Daily Task</label>
            <Switch
              onChange={handleAdminChange}
              checked={DailyTask}
              onColor="#4458b8"
              uncheckedIcon={false}
              checkedIcon={false}
              boxShadow="0px 1px 5px rgba(0, 0, 0, 0.3)"
              height={15}
              width={42}
              className="react-switch ms-2"
              id="material-switch"
            />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default VisitsFilter
